import { ASSURANCE_CHECK_FIELD_ID } from './image_metadata_constants';
export const ASSURANCE_WARNING_MESSAGES = {
    [ASSURANCE_CHECK_FIELD_ID.ITEMIZED_MEAL_RECEIPT_CHECK]: {
        title: 'Missing Meal Itemization:',
        content: 'This meal expense may require an itemized receipt. Review the expense and request the detailed receipt if needed.'
    },
    [ASSURANCE_CHECK_FIELD_ID.EXCESSIVE_TIP_DETECTION]: {
        title: 'Excessive Tip:',
        content: 'The tip on this receipt exceeds 25%. Review the tip amount and percentage.'
    },
    [ASSURANCE_CHECK_FIELD_ID.FAKE_RECEIPT_DETECTION]: {
        title: 'Issues with receipt authenticity:',
        content: "This receipt's image content suggests potential manipulation. Review the receipt for authenticity."
    },
    [ASSURANCE_CHECK_FIELD_ID.VENDOR_LEGITIMACY]: {
        title: 'Vendor could not be verified:',
        content: 'The vendor for this expense could not be confirmed through our verification process. Review the name and location for errors or add missing details.'
    },
    [ASSURANCE_CHECK_FIELD_ID.AMOUNT_ANOMALY_DETECTION]: {
        title: 'Unusual expense amount:',
        content: 'This expense shows an unusual cost, quantity, or item price compared to typical values. Review for potential errors or out-of-policy spending.'
    },
    [ASSURANCE_CHECK_FIELD_ID.ALCOHOL_DETECTION]: {
        title: 'Meal Alcohol Detected:',
        content: 'Alcohol has been identified on this meal receipt. Review the details for policy compliance.'
    },
    [ASSURANCE_CHECK_FIELD_ID.OUTSIDE_BUSINESS_HOURS]: {
        title: 'Non-Business Day Spend:',
        content: "This expense occurred on a weekend or holiday. Review for compliance with your company's off-hours spending policy."
    },
    [ASSURANCE_CHECK_FIELD_ID.LINE_ITEM_MISMATCH]: {
        title: "Expense and receipt details don't match:",
        content: "This expense has differences from the receipt data. See which fields don't match."
    }
};
